<template>
	<div class="px-lg-2 px-xl-4 font-14">
		<form
			action="https://www.adquiramexico.com.mx/clb/endpoint/difarmer"
			id="multipagos"
			method="post"
			name="multipagos"
			ref="multipagos"
		>
			<!--pruebas action="https://prepro.adquiracloud.mx/clb/endpoint/difarmer/"-->
			<!--pruebas mp_account=8658-->
			<!--productivo action="https://www.adquiramexico.com.mx/clb/endpoint/difarmer"-->
			<!--productivo mp_account=8998-->

			<!-- Codigo de la empresa en multipagos -->
			<input name="mp_account" type="hidden" value="8998" />
			<!--Puede ser el codigo del cliente (de hecho lo es) -->
			<input name="mp_order" type="hidden" v-model="multipagos.mp_order" />
			<!-- Es el id del pedidosWebEnc -->
			<input name="mp_reference" type="hidden" v-model="multipagos.referencia" />
			<!-- 1 - Multipagos avanzados-->
			<input name="mp_product" type="hidden" value="1" />
			<!-- codigo de la sucursal a la que pertenece el usuario 1 = DIFARMER, 2 = PX DURANGO, 3 = PX CHIHUAHUA 4 = PX TORREON -->
			<input name="mp_node" type="hidden" value="1" />
			<!-- 1 - Pago en línea -->
			<input name="mp_concept" type="hidden" value="1" />
			<!-- nimodo que no sepas que es :) -->
			<input name="mp_amount" type="hidden" v-model="multipagos.mp_amount" />
			<!-- Nombre del cliente que paga -->
			<input name="customername" type="hidden" v-model="multipagos.mp_customername" />
			<!-- 1 - pesos-->
			<input name="mp_currency" type="hidden" value="1" />
			<!-- firma generada -->
			<input name="mp_signature" type="hidden" v-model="multipagos.mp_signature" />
			<!-- url a la que retorna el pago exitos-->
			<input :value="this.apiUrl + 'pagos-especial/pago-exitoso'" name="mp_urlsuccess" type="hidden" />
			<!-- url a la que retorna el pago fallido-->
			<input :value="this.apiUrl + 'pagos-especial/pago-fallido'" name="mp_urlfailure" type="hidden" />
			<!-- url a la que retorna si el usuario le da al boton regresar en la pagina de multipagos-->
			<input name="mp_urlback" type="hidden" v-model="mp_urlback" />
			<!--<button type="submit">prueba</button>-->
		</form>
		
		<!-- Encabezado de ubicación (Breadcum)-->
		<div class="row d-flex align-items-center">
			<div class="col-12 col-sm-7 pl-0">
				<nav aria-label="breadcrumb ">
					<ol class="breadcrumb pl-0">
						<li class="breadcrumb-item">Pago en Linea</li>
					</ol>
				</nav>
			</div>
		</div>
		
		<div class="row d-flex align-items-center px-3 mb-3 bg-white py-2">
			<span class="mr-3">Importe:</span>
			<input
				@blur="calcular"
				class="form-control mr-2 txtimporte form-control-sm text-right"
				oninput="event.target.value = event.target.value.replace(/[^0123456789.]*/g,'');"
				ref="inputpago"
				type="text"
				v-model="importePagar"
				v-on:focus="importePagarFocus"
				v-on:keydown.enter.prevent="calcular"
			/>
			<button class="btn btn-aplicar btn-sm" v-on:click.prevent="calcular">Aplicar</button>
		</div>

		<div class="row">
			<div class="col-12">
				<table class="table table-sm font-14" ref="tablaPagos">
					<thead class="thead">
						<tr>
							<th class="text-center">
								<input type="checkbox" v-model="pagarTodos" v-on:change="calcularTodo" />
							</th>
							<th class="d-none d-md-table-cell text-center">Estatus</th>
							<th class="text-center">Documento</th>
							<th class="text-center">Vencimiento</th>
							<th class="text-center d-none d-lg-table-cell">Días vencido</th>
							<th class="text-right">Importe</th>
							<th class="text-right d-none d-lg-table-cell">Abono real</th>
							<th class="text-right d-none d-lg-table-cell">Abono virtual</th>
							<th class="text-right d-none d-lg-table-cell">Saldo actual</th>
							<th class="text-right d-none d-md-table-cell">Abono</th>
							<th class="text-right d-none d-md-table-cell">Saldo nuevo</th>
						</tr>
					</thead>
					<tbody v-if="antiguedad">
						<tr :key="index" v-for="(saldo, index) in antiguedad.detalle">
							<td class="text-center bg-white">
								<input
									:disabled="saldo.DeshabilitarCheck"
									:id="'check-'+index"
									type="checkbox"
									v-model="saldo.checked"
									v-on:change="update"
								/>
							</td>
							<td class="d-none d-md-table-cell bg-white text-center">
								<span class="b-danger m-auto text-white" v-show="saldo.color == 1">Vencido</span>
								<span class="b-warning m-auto" v-show="saldo.color == 2">Por vencer</span>
								<span class="b-success m-auto text-white" v-show="saldo.color == 3">No vencido</span>
							</td>
							<td class="text-center bg-white">{{saldo.documento}}</td>
							<td class="text-center d-block d-md-none d-flex justify-content-center bg-white">
								<span
									class="b-danger"
									v-show="saldo.color == 1"
								>{{ saldo.fechaVencimiento | format-date('DD/MMM/YYYY') }}</span>
								<span
									class="b-warning"
									v-show="saldo.color == 2"
								>{{ saldo.fechaVencimiento | format-date('DD/MMM/YYYY') }}</span>
								<span
									class="b-success"
									v-show="saldo.color == 3"
								>{{ saldo.fechaVencimiento | format-date('DD/MMM/YYYY') }}</span>
							</td>
							<td
								class="text-center d-none d-md-table-cell bg-white"
							>{{ saldo.fechaVencimiento | format-date('DD/MMM/YYYY') }}</td>
							<td class="text-center d-none d-lg-table-cell bg-white">{{ saldo.diasVencido}}</td>
							<td class="text-right bg-white">{{ saldo.importe | format-number('0,0.00') }}</td>
							<td
								class="text-right d-none d-lg-table-cell bg-white"
							>{{ saldo.abonoReal | format-number('0,0.00') }}</td>
							<td
								class="text-right d-none d-lg-table-cell bg-white"
							>{{ saldo.abonoVirtual | format-number('0,0.00') }}</td>
							<td
								class="text-right d-none d-lg-table-cell bg-white"
							>{{ saldo.saldoActual | format-number('0,0.00') }}</td>
							<td
								class="text-right d-none d-md-table-cell bg-white"
							>{{ saldo.abono | format-number('0,0.00') }}</td>
							<td
								class="text-right d-none d-md-table-cell bg-white"
							>{{ saldo.saldo | format-number('0,0.00') }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="float-pagar">
			<div class="importe mb-3">
				<span>Total a abonar:</span>
				<div>{{ importeBanco | format-number('$0,0.00') }}</div>
			</div>
			
			
			<button @click="mostrarMensajePago" v-if="!this.soloConsulta()" class="btn btn-block">Proceder con el pago</button>
			<!-- <button @click="pagar" class="btn btn-block">Proceder con el pago</button> -->
		</div>

		<b-modal 
		hide-footer 
		id="modal-pagos-pendientes" 
		size="lg"
		hide-header>
			<div class="mx-3 mt-4">
				<h5 v-if="esPagoPendiente" class="text-center mb-4">!Hemos detectado un intento de pago no concretado!</h5>
				<p class="text-justify text-wrapper">
					<!-- ¡Hemos detectado un intento de pago no concretado!<br />Puede completar el proceso de pago o cancelarlo. -->
					Recuerda dar clic en el botón <b>"Continuar"</b> en la página de cobro de BBVA para completar correctamente el pago
				</p>
				<div class=" text-center">
					<label class="font-10 d-block">Imagen de muestra</label>
					<img class="w-50 shadow border"  src="@/assets/img-priv/pagoBBVAcompleto.png" alt="imagen para finalizar pago en bancomer" />
				</div>
				
				<!-- <a href="http://www.difarmer.com/imagenes/logo.png" target="_blank" title="ejemplo pago BBVA">ver ejemplo</a> -->
				<div class="mt-3">
					<p >
						o en el botón <b>"Regresar"</b> si no deseas continuar con el pago.
					</p>
					<!-- <label class="font-10 d-block">Vista previa:</label>
					<img class="shadow border"  src="@/assets/BBVAregresar.png" alt="imagen de boton regresar" />					 -->
				</div>


			</div>

			<div class="d-flex justify-content-center mt-4">
				<!-- <Button @click="pagarPendientes" block class="m-3 btn btn-primary">Proceder con el pago</Button> -->
				<Button :disabled="deshabilitaPagar" @click="procederPago(true)" block class="m-3 btn btn-primary" v-if="!this.soloConsulta()">Proceder con el pago</Button>
				<!-- <Button @click="cancelarPago" block class="m-3 btn btn-secondary">Cancelar pendiente de pago</Button> -->
			</div>
		</b-modal>
	</div>
</template>
<script>
	import config from "@/services/config"
	import servicio from "@/services/servicio-adeudos-pagos"
	import Swal from "sweetalert2"

	export default {
		data() {
			return {
				antiguedad: null,
				importePagar: 0,
				importePagarFormat: 0,
				pagarTodos: false,
				importeBanco: 0,
				multipagos: {
					mp_order: "", // codigo del cliente
					referencia: 0, //IdPago
					mp_customername: "", // nombre del cliente
					mp_signature: "",
					mp_amount: 0,
				},
				documentosPagar: [],
				mp_urlback: config.apiUrl + "pagos-especial/pago-cancelar/",
				pagosPendientes: null,
				esPagoPendiente: false,
				deshabilitaPagar:false,
			}
		},
		mounted() {
			this.carritoConsultarCantidad()
			this.cargar()
			this.obtenerNotificaciones()

			// if(this.usuarioGlobal().codCliente==12362){
			// 	this.carritoConsultarCantidad()
			// 	this.cargar()
			// 	this.obtenerNotificaciones()
			// }
			// else{
			// 	window.location.href = 'https://www.difarmer.com/alpha/VerifyClient2.aspx?tid=' + window.localStorage.token + '&rtid=' + window.localStorage.refreshToken + '&rurl=https://www.difarmer.com/Agentes/Clientes/antiguedadsaldos.aspx?pagar=1'
			// }
		},
		computed: {
			apiUrl() {
				return config.apiUrl
			},
		},
		methods: {
			pagar() {
				this.documentosPagar = this.antiguedad.detalle.filter(
					(item) => item.checked == true
				)

				if (this.documentosPagar.length > 0) {
					servicio
						.guardarIntento(this.documentosPagar)
						.then((r) => {
							if (r.value) {
								new Promise((resolver, rechazar) => {
									this.multipagos.referencia = r.data.idPago
									this.multipagos.mp_signature = r.data.signature
									this.multipagos.mp_order = this.usuarioGlobal().codCliente
									this.multipagos.mp_customername = this.usuarioGlobal().name
									this.multipagos.mp_amount = Number(this.importeBanco).toFixed(2)

									this.mp_urlback += r.data.idPago

									resolver()
									rechazar()
								})
									.then(() => {
										this.$refs.multipagos.submit()
									})
									.catch((error) => {
										console.log(error)
									})
							}
						})
						.catch((error) => {
							console.error(error)
						})
				}
			},
			importePagarFocus() {
				this.$refs.inputpago.select()
			},
			importePagarBlur() {
				this.calcular()
			},
			calcularTodo() {
				this.importePagar = 0
				this.importePagarFormat = 0

				if (this.pagarTodos) {
					this.antiguedad.detalle.forEach(
						(item) => (this.importePagar += item.saldoActual)
					)

					//this.importePagar = this.importePagar.toFixed(2)
					//this.importePagarFormat = this.importePagar.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
				} else {
					this.antiguedad.detalle.forEach((item) => {
						item.saldo = item.saldoActual
						item.abono = 0
					})
				}

				this.calcular()
			},
			isNumeric: function (n) {
				return !isNaN(parseFloat(n)) && isFinite(n)
			},
			calcular() {
				let abonoTotal = parseFloat(0)
				if (this.isNumeric(this.importePagar)) {
					this.importePagar = parseFloat(this.importePagar).toFixed(2)
					this.importePagarFormat = parseFloat(this.importePagar)
						.toFixed(2)
						.replace(/\d(?=(\d{3})+\.)/g, "$&,")
				} else {
					this.importePagar = 0.0
				}

				let importeDistribuir = this.importePagar

				var detalle = this.antiguedad.detalle.map((item) => {
					item.checked = 0
					item.abono = 0
					item.saldo = item.saldoActual

					if (importeDistribuir > 0) {
						if (item.saldoActual > 0) {
							item.checked = true

							if (item.saldo <= importeDistribuir) {
								item.abono =  parseFloat(item.saldo).toFixed(2)
							} else {
								item.abono = parseFloat(importeDistribuir).toFixed(2)
							}

							item.saldo =  parseFloat(item.saldo).toFixed(2) - parseFloat(item.abono).toFixed(2)
							importeDistribuir = (parseFloat(importeDistribuir).toFixed(2) - parseFloat(item.abono).toFixed(2)).toFixed(2)
							abonoTotal = (parseFloat(abonoTotal) + parseFloat(item.abono)).toFixed(2)
						}
					}
					return item
				})
				if(this.importePagar > abonoTotal){
					this.importePagar = abonoTotal
				}
				this.antiguedad.detalle = detalle
				this.importeBanco = this.importePagar
			},
			calcularCheck() {
				this.importePagar = 0
				this.importePagarFormat = 0
				this.antiguedad.detalle.forEach((item) => {
					if (item.checked) {
						item.abono = item.saldoActual

						this.importePagar += item.abono
					} else {
						item.abono = 0
					}

					item.saldo = item.saldoActual - item.abono
				})

				this.importePagar = this.importePagar.toFixed(2)
				this.importePagarFormat = parseFloat(this.importePagar)
					.toFixed(2)
					.replace(/\d(?=(\d{3})+\.)/g, "$&,")
				this.importeBanco = this.importePagar
			},
			update() {
				this.calcularCheck()
			},
			cancelarPago() {
				if (this.pagosPendientes.length > 0) {
					servicio
						.cancelar(this.pagosPendientes[0].idPagosWebEnc)
						.then((r) => {
							console.log(r)
							if (!r.value) {
								Swal.fire({
									text: r.message,
									icon: "warning",
								})
							}
							this.$bvModal.hide("modal-pagos-pendientes")
							this.cargar()
						})
						.catch((error) => {
							console.log(error)
						})
				}
			},
			pagarPendientes() {
				new Promise((resolver, rechazar) => {
					this.multipagos.referencia = this.pagosPendientes[0].referencia
					this.multipagos.mp_signature = this.pagosPendientes[0].signature
					this.multipagos.mp_order = this.pagosPendientes[0].mp_order
					this.multipagos.mp_customername = this.pagosPendientes[0].mp_customername
					this.multipagos.mp_amount = this.pagosPendientes[0].mp_amount.toFixed(2)

					console.log("mp_urlback-" + this.mp_urlback)
					this.mp_urlback += this.pagosPendientes[0].idPagosWebEnc
					console.log(this.mp_urlback)

					resolver()
					rechazar()
				}).then(() => {
					this.$refs.multipagos.submit()
				})
			},
			cargar() {
				try{
					this.$loading(true)
					servicio
						.pendientes()
						.then((r) => {
							this.$loading(false)

							if (r.value) {
								this.pagosPendientes = r.data
								this.esPagoPendiente = true;
								//console.log(r.data)
								this.$bvModal.show("modal-pagos-pendientes")
							} else {
								this.$loading(true)
								servicio
									.adeudos()
									.then((r) => {
										this.$loading(false)
										if (!r.value) return

										//console.log('r.data', r.data)
										this.antiguedad = r.data

										this.antiguedad.detalle.map((item) => {
											item.saldoActual =
												item.importe -
												item.abonoReal -
												item.abonoVirtual -
												item.notaCredito

											item.saldo = item.saldoActual
											item.abono = 0
											item.checked = false
										})

										this.antiguedad.detalle.forEach((element) => {
											this.$set(
												element,
												"DeshabilitarCheck",
												element.saldo == 0 ? true : false
											)
										})
										this.$nextTick(()=>{
											let tabla = this.$refs.tablaPagos
											this.$floatThead.ini(tabla)
										})
									})
									.catch((error) => {
										this.$loading(false)
										console.log(error)
									})
							}
						})
						.catch((error) => {
							this.$loading(false)
							console.log(error)
						})
				}
				catch(error){
					console.log(error)
				}
			},
			mostrarMensajePago()
			{
				if(this.importeBanco >= 1)
				{
					if(this.antiguedad != null)
					{
						if(this.antiguedad.detalle.filter((item) => item.checked == true).length > 0)
						{
							this.esPagoPendiente = false;
							this.$bvModal.show("modal-pagos-pendientes")
						}
					}
					else if(this.esPagoPendiente)
					{
						this.$bvModal.show("modal-pagos-pendientes")
					}
				}
			},
			procederPago(){
				this.deshabilitaPagar = true;
				if(!this.esPagoPendiente)
				{
					try
					{
						this.$loading(true)
						servicio
							.pendientes()
							.then((r) => {
								this.$loading(false)
								
								if (r.value) 
								{
									this.pagosPendientes = r.data
									this.esPagoPendiente = true;
									//this.$bvModal.show("modal-pagos-pendientes")
									Swal.fire({
										text: 'No se puede proceder con el pago porque ya tiene uno pendiente.',
										icon: "warning",
										confirmButtonText:"Ok"
									}).then(() =>{
										let time = new Date().getTime();
										this.$emit("sideBarSelect", time, 0);
										this.$router.push({ path: "/clientes/" })
									})
								} 
								else 
								{
									this.pagar();
								}
							})
							.catch((error) => {
								this.$loading(false)
								console.log(error)
							})
					}
					catch(error){
						console.log(error)
					}				
				}
				else
				{
					this.pagarPendientes();
					//console.log("pagos pendientes")					
				}
			}
		},
	}
</script>
<style scoped>
	.container-fluid {
		font-size: 14px !important;
	}

	.float-pagar {
		position: fixed;
		bottom: 3em;
		right: 3em;
		width: 300px;
		background-color: #dedede;
		padding: 1em 1.6em;
		color: #335198;
		font-weight: bold;
	}

	.float-pagar .importe {
		display: flex;
		justify-content: space-around;
	}

	.float-pagar .btn {
		background-color: #335198;
		color: #fff;
	}

	.float-pagar .btn:hover {
		background-color: #273c6e;
	}

	.thead {
		background-color: #335198;
		color: #fff;
	}

	.thead > tr > th {
		padding: 0.5em;
	}

	.b-danger {
		background-color: #ff0000;
		color: white;
		padding: 0.2em 1em;
		border-radius: 5px;
		width: 7em;
		display: block;
		text-align: center;
		font-weight: bold;
	}

	.b-warning {
		background-color: #f1c240;
		color: var(--bg-menu-blue);
		padding: 0.2em 1em;
		border-radius: 5px;
		width: 7em;
		display: block;
		text-align: center;
		font-weight: bold;
	}

	.b-success {
		background-color: #03b94f;
		color: var(--bg-menu-blue);
		padding: 0.1em 0em;
		border-radius: 5px;
		width: 7em;
		display: block;
		text-align: center;
		font-weight: bold;
	}

	table {
		color: #273c6e;
	}

	.Titulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: bold;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.txtimporte {
			width: 150px;
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
			font-size: 14px;
		}
		.btn-aplicar {
			background-color: #335198;
			color: #fff;
			width: 150px;
			font-size: 14px;
		}
		.table-font-size {
			font-size: 12px;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.txtimporte {
			width: 200px;
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.btn-aplicar {
			background-color: #335198;
			color: #fff;
			width: 150px;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.txtimporte {
			width: 200px;
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.btn-aplicar {
			background-color: #335198;
			color: #fff;
			width: 150px;
		}

		.float-pagar {
			position: fixed;
			bottom: 3em;
			right: 1em;
			width: 300px;
			background-color: #dedede;
			padding: 1em 1.6em;
			color: #335198;
			font-weight: bold;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.txtimporte {
			width: 200px;
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.btn-aplicar {
			background-color: #335198;
			color: #fff;
			width: 150px;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.txtimporte {
			width: 200px;
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.btn-aplicar {
			background-color: #335198;
			color: #fff;
			width: 200px;
		}
	}


</style>>
